import React from 'react';
import './style.scss';

export type EstablishLinkProps = {
  linkTitle?: string;
  linkUrl?: string;
  onClick?: () => void;
};

export const EstablishLink = (props: EstablishLinkProps) => {
  const { linkTitle, linkUrl, onClick } = props;
  return (
    <a
      className="establishLink"
      href={linkUrl}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => {
        onClick && onClick();
      }}
    >
      {linkTitle}
    </a>
  );
};
